import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import api from '../../services/api';

const SwitchPickupRouteModal = ({
  handleClose, open, handleConfirm, currentRoutes, network,
}) => {
  const [selectedRoutes, setSelectedRoutes] = useState([0]);
  const [routes, setRoutes] = useState([]);
  const [unassignedPickups, setUnassignedPickups] = useState({});

  useEffect(() => {
    if (currentRoutes.length) setSelectedRoutes(currentRoutes);
    else setSelectedRoutes([0]);
  }, [currentRoutes.length]);

  useEffect(() => {
    api.rlNetwork.show(network.id, { sort: 'package_cluster', direction: 'asc' }).then((res) => {
      setRoutes(res.routes);
      setUnassignedPickups(res.unassigned);
    });
  }, [network]);

  const updateRoutes = (id, index) => {
    setSelectedRoutes((prev) => {
      const ids = [...prev];
      ids[index] = +id;
      return ids;
    });
  };

  return (
    <Dialog
      className="dialog-sm"
      open={open}
      onClose={handleClose}
      aria-labelledby="preview-modal-title"
    >
      <DialogTitle id="preview-modal-title">
        Switch Pickup
      </DialogTitle>
      <DialogContent className="preview-item-container" id="preview-modal-dialog">
        <div className="row">
          <div className="col-sm-12 form-group">
            <div>New Route</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              { selectedRoutes.map((selectedRouteId, index) => (
                <select
                  key={selectedRouteId || index}
                  name="route_id"
                  id="route_id"
                  className="form-control"
                  value={selectedRouteId}
                  onChange={e => updateRoutes(e.target.value, index)}
                >
                  <option value="">Select route</option>
                  {routes.filter(route => !selectedRoutes.find(id => route.id === id) || selectedRouteId === route.id).map(route => <option key={route.id} value={route.id}>{`${route.package_cluster.region_id_lvl1} @ ${route.package_cluster.airport_code} ${route.driver ? `${route.driver.user.first_name} ${route.driver.user.last_name} [${route.driver.user.email}]` : ''} - ${route.pickup_count_for_user_role}/${unassignedPickups[route.package_cluster_id] || 0}`}</option>)}
                </select>
              )) }

              <button className="btn btn-primary" onClick={() => setSelectedRoutes(p => [...p, 0])}>Add another route</button>
            </div>
          </div>
        </div>
        <button onClick={() => handleConfirm(selectedRoutes.filter(n => n))} disabled={(currentRoutes.length === selectedRoutes.length && selectedRoutes.every((i, index) => i === currentRoutes[index]))} className="btn btn-primary popup_cancel_btn">Confirm</button>
        <button onClick={handleClose} className="btn btn-primary pull-right popup_cancel_btn">Cancel</button>
      </DialogContent>
    </Dialog>
  );
};

SwitchPickupRouteModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  currentRoutes: PropTypes.arrayOf(PropTypes.number),
  open: PropTypes.bool,
  network: PropTypes.instanceOf(Object).isRequired,
};

SwitchPickupRouteModal.defaultProps = {
  currentRoutes: [],
  open: false,
};

export default SwitchPickupRouteModal;
